<template>
  <div class="contact-table pb-5" id="contact-table">
    <v-simple-table class="table-layout table-contact table-fixed">
      <template v-slot:default>
        <thead>
          <tr style="background-color: #1C3545 !important;">
            <th
              v-for="(attribute, index) in rowAttributes"
              :key="index + '_th'"
              :ref="'th_' + attribute.name"
              v-show="statusRowAttribute(attribute.name)"
              :class="attribute.sticky ? 'scroll-left' : ''"
              :style="{ left: attribute.left, right: attribute.right, 'max-width': attribute.width, 'min-width': attribute.width}"
            >
              {{attribute.title}}
              <div data-v-22d75c44 class="border-bottom-table"></div>
            </th>
            <th class="th_action" style="border-right: 1px solid #d2d2d2">
              Hành động
              <div data-v-22d75c44 class="border-bottom-table"></div>
            </th>
          </tr>
        </thead>
        <tbody
          class="bg-hover"
          :class="contact && contact.callingStatus ? contact.callingStatus : ''"
          :ref="`contact-row-${index}`"
          v-for="(contact, index) in contacts"
          :key="`${contact.id}_${index}`"
        >
          <tr>
            <td
                v-for="(attribute, index) in rowAttributes"
                :key="index"
                v-show="statusRowAttribute(attribute.name)"
                :class="attribute.sticky ? 'scroll-left' : ''"
                :style="{ 'text-align': attribute.textAlign + '!important' , left: attribute.left, right: attribute.right, 'max-width': attribute.width, 'min-width': attribute.width}"
            >
              <span v-if="attribute.name === 'addition_info'">
                <v-tooltip bottom v-if="_.get(contact, 'order.products', []).length >= 4">
                  <template v-slot:activator="{ on: tooltip }">
                    <div
                        class="user-comment"
                        v-on="tooltip"
                        style="white-space: pre-line"
                    >
                      <p v-for="(product, indexProduct) in _.get(contact, 'order.products', [])">
                        <span v-if="indexProduct < 2">{{product.name}}</span>
                        <span v-else-if="indexProduct === 2">{{product.name}}, ...</span>
                      </p>
                    </div>
                  </template>
                   <p v-for="product in _.get(contact, 'order.products', [])">
                      <span>{{product.name}}</span>
                   </p>
                </v-tooltip>
                <span v-if="_.get(contact, 'order.products', []).length < 4">
                  <p v-for="product in _.get(contact, 'order.products', [])">{{product.name}}</p>
                </span>
              </span>
              <span v-else-if="attribute.name === 'amount'">{{ formatPriceNew(_.get(contact, attribute.name, 0), ' ' + _.get(contact, 'currency', 'VNĐ'))  || '-' }}</span>
              <span v-else-if="attribute.name === 'status'" :style="`color: ${_.get(mapStatusCode[contact.status] ,'color', '')}`">{{ _.get(mapStatusCode[contact.status] ,'name', '') }}</span>
              <span v-else-if="attribute.name === 'transactionNumber'" style="color: #1890FF;">{{ _.get(contact, attribute.name, '') || '-' }}</span>
              <span v-else>{{ _.get(contact, attribute.name, '') || '-' }}</span>
            </td>

            <td class="action-cell" :rowspan="contact.rowspan">
              <div class="action">
                <v-menu offset-y v-if="statusCallCenter && contact.contactType == 'main' && false">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                          size="16"
                          width="20"
                          height="20"
                          class="mr-1"
                          icon
                          small
                          color="success"
                          v-bind="attrs"
                          v-on="{...tooltip, ...menu}"
                        >
                          <v-icon size="16">mdi-phone</v-icon>
                        </v-btn>
                      </template>
                      <span>Gọi cho khách hàng</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item
                      @click="clickExecuteCall(contact, _.get(contact, 'studyDate', ''))"
                      class="main-studyDate"
                    >
                      <v-list-item-title>{{_.get(contact, 'studyDate', '')}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-for="(phone, index) in contact.phoneRelated"
                      :key="index"
                      @click="clickExecuteCall(contact, phone)"
                      class="sub-studyDate"
                    >
                      <v-list-item-title>{{phone}}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-tooltip v-else-if="statusCallCenter && false" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      size="16"
                      width="20"
                      height="20"
                      @click="clickExecuteCall(contact, _.get(contact, 'studyDate', ''))"
                      class="mr-1"
                      icon
                      small
                      color="success"
                      v-on="on"
                    >
                      <v-icon size="16">mdi-phone</v-icon>
                    </v-btn>
                  </template>
                  <span>Gọi cho khách hàng</span>
                </v-tooltip>
                <!-- Hiển thị khi 'trạng thái là Chưa xác nhận' và 'hình thức là shopee' -->
                <v-tooltip
                  bottom
                  v-if="
                    _.get(contact, 'status', '') === STATUS_CHUA_XAC_NHAN &&
                      _.get(contact, 'paymentName', '') === PAYMENT_SHOPEE
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mr-1"
                      @click="reCheck(contact)"
                      medium
                      size="10"
                      width="18"
                      height="18"
                      v-on="on"
                      fab
                      color="#FFD643"
                    >
                      <!-- <span style="text-transform: capitalize;">Re-check</span> -->
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>Re-check</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">                    
                    <v-icon color="#0395EE" v-on="on" class="ml-1" style="cursor: pointer;" @click="showDetail(contact)">mdi-information</v-icon>
                  </template>
                  <span>Xem chi tiết giao dịch</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-if="contacts.length == 0">
          <tr>
            <td colspan="11" class="scroll-layout-left">
              <common-no-result />
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <!-- Popup Phiếu thu -->
    <popupReceipt
      v-if="dialogReceipt"
      :dialogReceipt="dialogReceipt"
      :dataDialogReceipt="dataDialogReceipt"
      @close-popup="dialogReceipt = false"
      @re-check-order = reCheck($event)
    ></popupReceipt>
  </div>
</template>
<script>
import TokenService from '@/helpers/token'
import handleSchedule from "@/mixins/handleSchedule";
import { userPositions, regex, CLASS_OF_STUDENT } from '@/helpers/constants';
import OrderRepository from "@/repositories/OrderRepository";

export default {
  $_veeValidate: {
    validator: "new",
  },
  mixins: [handleSchedule],
  components: {
    popupReceipt: () => import("@/pages/payment-hub/receipts.vue"),
  },
  props: {
    filterForm: {
      type: Object,
      default: () => ({})
    },
    contacts: {
      type: Array,
      default: () => []
    },
    rowAttributes: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    },
    distributionStatus: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: () => 0
    },
    limit: {
      type: Number,
      default: () => 20
    },
    mapStatusCode: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      dataContact: {},
      studyDate: '',
      oldPosition: 0,
      snackbar: false,
      valid: true,
      user: {},
      userPositions,
      regex,
      CLASS_OF_STUDENT,
      STATUS_CHUA_XAC_NHAN: 6,
      PAYMENT_SHOPEE: "SP",
      dialogReceipt: false,
      dataDialogReceipt: {},
    };
  },
  created() {
    this.user = TokenService.getUser();
  },
  computed: {
    statusCallCenter() {
      return (
        this.checkAuthorization('call_center_read') ||
        this.checkAuthorization('call_center_view_all')
      );
    },
    countContactSelect() {
      return this.contacts.filter((dataContact) => dataContact.checkbox).length;
    },
  },
  methods: {
    statusRowAttribute(attributeName) {
      return (
        this.rowAttributes.findIndex(
          attribute => attribute.value && attribute.name == attributeName
        ) !== -1
      );
    },
    clickExecuteCall(contact, phone) {
      let user = TokenService.getUser()
      if (user.ext) {
        let data = {
          studyDate: phone,
          showCreateAppointment: false,
          contactId: contact.id,
          callcenter_id: user.callcenter_id,
          mainId: contact.mainId,
          mainstudyDate: contact.phoneRelated[0],
          store: this.filterForm.store
        }
        Bus.$emit('voice-call-show-popup', data)
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.'
        })
      }
    },
    onChangeCheckboxAll() {
      this.contacts.forEach(contact => {
        const contactTemp = contact;
        contactTemp.checkbox = this.filterForm.checkboxAll && !contact.mainId;
      });
    },
    async reCheck(contact) {
      const res = await OrderRepository.inquirePaymentHub(contact.transactionNumber)
      if (res && res.success){
        Bus.$emit('contact-list-filter', this.filterForm)
      }
    },
    checkBoxOne() {
      const changeContactList = this.contacts.filter(
          contact => contact.checkbox
      );
      if(changeContactList?.length === this.contacts?.length){
        this.filterForm.checkboxAll = true;
      }else{
        this.filterForm.checkboxAll = false;
      }
    },
    showDetail(contact) {
      this.dialogReceipt = true;
      const data = {
        orderId: contact.paymentReference,
        transactionNumber: contact.transactionNumber,
      };
      this.dataDialogReceipt = data;
    }
  },
};
</script>

<style scoped>
.table-contact tbody tr {
  height: 50px;
}
.table-contact table {
  border: 1px solid #d2d2d2;
}
.table-contact table .bg-hover:hover .child-table td:last-child {
  background: #e0e0e0;
}
.table-contact table .bg-hover:hover tr .scroll-layout-left {
  background: #e0e0e0;
}
.table-contact table .in-call tr {
  background: #90EE90;
}
.table-contact table .in-call tr .scroll-layout-left{
  background: #90EE90;
}
.table-contact table .calling tr {
  background: #FA8072;
}
.table-contact table .calling tr .scroll-layout-left{
  background: #FA8072;
}
.table-contact thead tr {
  height: 35px;
}
.table-contact thead th {
  border-right: 1px solid #d2d2d2;
  font-size: 14px !important;
}
.table-contact thead th:last-child {
  border-right: 0;
}
.table-contact thead .th-id {
  min-width: 50px;
}
.table-contact .child-table td:last-child {
  border-right: 1px solid #d2d2d2;
}
.table-contact .child-table:hover {
  background: rgba(0, 0, 0, 0.11) !important;
}
.table-contact td {
  position: relative;
  border-right: 1px solid #d2d2d2;
  font-size: 14px !important;
  color: #000000;
}
.table-contact td:last-child {
  border-right: 0;
}
.table-contact .table-layout-checkbox {
  position: relative;
}
.table-contact .table-layout-checkbox .v-input--selection-controls__input {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.v-data-table td {
  font-weight: 300;
  padding: 12px 8px;
}

/deep/ tbody td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  text-align: left;
  font-size: 15px !important
}

tbody .action-cell {
  text-align: center;
}

tbody .tr-numerical-order {
  text-align: center;
}

thead th {
  height: 30px;
}


.scroll-left {
  /* position: fixed; */
  position: sticky;
  background: #fff;
  border-left: 1px solid #d2d2d2!important;
}

td.scroll-left {
  z-index: 1;
}
/deep/ .v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th.scroll-left {
  border-bottom: 0px !important;
  position: sticky;
  top: 0;
  z-index: 3;
}

/deep/ .table-layout-checkbox .v-input--selection-controls__input {
  z-index: 1;
}
/deep/.th_teacher {
  min-width: 170px;
}
/deep/.th_parentFullName {
  min-width: 170px;
}
/deep/.th_description {
  min-width: 200px;
}
/deep/.th_user {
  min-width: 170px;
}
/deep/.th_email {
  min-width: 150px;
}
/deep/.th_detailAddress {
  min-width: 250px;
}

/deep/ .th_productDescription {
  max-width: 250px;
}

/deep/ .th_numberOfCall {
  max-width: 20px;
}

/deep/ .th_appointment {
  min-width: 200px;
}

.appointment-time-wrapper {
  padding: 2px 0px;
  border: thin solid #A9A9A9;
  border-radius: 5px;
  cursor: pointer;
  min-width: 140px;
}
.custom-span-title-study-result {
  color: black;
  font-size: 13px !important;
  text-transform: none !important;
}
/deep/ .btn-show-modal-study-result span.v-btn__content {
  justify-content: normal !important;
}
.icon-comment {
  margin-left: 5px;
}
.btn-show-modal-count-interaction {
  position: absolute;
  top: 20%;
  right: 0%;
}

/deep/ .v-text-field--is-booted .v-input__control .v-input__slot {
  border: 1px solid #d9dbe9 !important;
  height: 40px !important;
  padding: 0 12px !important;
  border-radius: 4px !important;
}
/deep/ .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #d9dbe9 !important;
}
/deep/ .v-text-field--is-booted {
  padding-top: unset !important;
  margin-top: unset !important;
}
/deep/
  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  border: 1px !important;
}
.trail-tag {
  padding: 0px 6px;
  font-weight: 400;
  display: inline-block;
  width: 32px;
  text-align: center;
}
.tn-tag-trial {
  color: #219653;
  border: 1px solid #219653;
}
.ch-tag-trial {
  color: #F2994A;
  border: 1px solid #F2994A;
}
.v-tag-trial {
  color: #4F4F4F;
  border: 1px solid #4F4F4F;
}
@media screen and (max-width: 767px) {
  /deep/ .scroll-layout-left {
    position: unset !important;
  }
  /deep/ .th_studyDate, .th_studyHour, .th_teacher, .th_checkbox, .th-id {
    position: sticky !important;
    left: unset !important;
  }
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: unset;
}
.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background: #94bdf6 !important;
}
.v-input--radio-group.v-input--radio-group--row .v-radio {
  margin-right: 8px !important;
}
.trail-tag {
  padding: 0px 6px;
  font-weight: 400;
  display: inline-block;
  width: 32px;
  text-align: center;
}
.tn-tag-trial {
  color: #219653;
  border: 1px solid #219653;
}
.ch-tag-trial {
  color: #f2994a;
  border: 1px solid #f2994a;
}
.v-tag-trial {
  color: #4f4f4f;
  border: 1px solid #4f4f4f;
}
</style>
<style lang="scss" scoped>
.contact-table {
  table {
    thead{
      tr {
        th {
          background-color: #1C3545 !important;
          color: white;
        }
      }
    }
    .flex-center {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>
